<template>
  <div class="adv-main">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="text-white modes_heading text-center">
            <h1>Adventure Mode</h1>
          </div>
        </div>
      </div>
      <div class="main_cart py-5 mb-5">
        <div class="row justify-content-center">
          <div class="col-3">
            <a href="#" class="weapon_cart weapon_img" @click="showMdl('guns')">
              <img
                src="images/weapon-select.webp"
                class="img-fluid"
                v-if="!selectedWeapon"
              />
              <img
                :src="getImage(selectedWeapon.img)"
                class="img-fluid weapon-cart--img"
                v-else
              />
            </a>
          </div>
          <div class="col-2" v-for="(item, i) in selectedChars" :key="i">
            <a href="#" class="weapon_cart">
              <img :src="getImage(item.data.img)" class="img-fluid char-img" />
            </a>
          </div>
          <div
            class="col-2"
            v-for="index in selectedChars ? 3 - selectedChars.length : 3"
            :key="index"
          >
            <a href="#" class="weapon_cart" @click="showMdl('characters')">
              <img src="images/char-select.png" class="img-fluid char-img" />
            </a>
          </div>
        </div>
        <div class="attack_btn my-5 text-center">
          <a href="#" @click="stake">Send</a>
        </div>
      </div>
      <teleport to="body">
        <transition name="slide">
          <StakeModal
            :error="error"
            v-if="showModal"
            :schema="card"
            :cardName="card"
            :isShow="showModal"
            v-on:modal-hide="hideMdl()"
          />
        </transition>
      </teleport>
    </div>
  </div>
</template>
<script>
import StakeModal from "../components/StakeModal";
import { mapGetters } from "vuex";
import ApiService from "../services";
export default {
  name: "Advanture",
  components: {
    StakeModal,
  },
  computed: {
    ...mapGetters(["selectedWeapon", "selectedChars"]),
  },
  data() {
    return {
      showModal: false,
      error: "",
    };
  },
  mounted() {
    ApiService.getStake((res) => {
      console.log(res);
      this.$store.commit("addStake", res);
      this.$router.push("/adv-reward");
    });
  },
  methods: {
    async stake() {
      if (this.selectedWeapon.asset_id && this.selectedChars.length == 3) {
        let postData = this.selectedChars.map((item) => item.asset_id);
        postData.push(this.selectedWeapon.asset_id);
        const data = {
          from: localStorage.getItem("wax_user"),
          asset_ids: postData,
          to: process.env.VUE_APP_CONTRACT,
          memo: "stake:advanture",
        };
        await ApiService.assetTransfer(
          data,
          (res) => {
            if (res.processed) {
              ApiService.successMsg();
              setTimeout(() => {
                this.$router.push("/adv-reward");
              }, 2000);
            }
          },
          (error) => {
            ApiService.errorMsg(error);
          }
        );
      } else {
        ApiService.errorMsg("you need 1 gun and 3 character to play.");
      }
    },
    async claim() {
      await ApiService.claim(
        (res) => {
          if (res.processed) {
            ApiService.successMsg();
          }
        },
        (error) => {
          ApiService.errorMsg(error);
        }
      );
    },
    showMdl(card) {
      this.showModal = true;
      this.card = card;
    },
    hideMdl() {
      this.showModal = false;
      this.card = "";
    },
    getImage(hash) {
      return ApiService.getImgUrl(hash);
    },
  },
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.char-img {
  padding: 0 12px;
}
.adv-main {
  background-image: url(/images/map_bg.png);
  height: 100%;
  width: 100%;
  background-color: #875724;
}
.modes_heading {
  margin-top: 110px;
  margin-bottom: 20px;
}
</style>